<template>
  <div class="py-2">
    <div class="py-2">
      <label for="inputState" class="block py-1 text-gray-700 text-sm font-bold mb-2">Select FdImm:</label>
      <select
        v-model="imm"
        class="block appearance-none w-auto bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
      >
        <option disabled value>Choose one</option>
        <option v-for="(imm, id) in imms" :value="imm.id" :key="id">{{ imm.name }}</option>
      </select>

      <label class="block py-1 text-gray-700 text-sm font-bold mb-2" for="post">Select Post:</label>
      <select
        v-model="service"
        class="block appearance-none w-auto bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
      >
        <option disabled value>Choose one</option>
        <option v-for="(service, id) in services" :value="service.id" :key="id">{{ service.name }}</option>
      </select>
      <button
        @click="calculateImm"
        class="my-3 p-1 bg-teal-400 text-white hover:bg-white hover:text-teal-400"
      >Calculate</button>
    </div>

    <div class="py-2">
      <router-link
        to="/fd-imm-table"
        class="p-1 text-white bg-teal-400 hover:text-teal-400 hover:bg-white"
      >
        <i class="fa fa-plus"></i>
        Add FdImm
      </router-link>
      <vue-excel-xlsx
        class="p-1 ml-2 text-white bg-teal-400 hover:text-teal-400 hover:bg-white"
        :data="products"
        :columns="columns"
      >
        <i class="fa fa-file-excel"></i>
        Export
      </vue-excel-xlsx>
    </div>

    <vue-good-table
      @on-selected-rows-change="selectionChanged"
      :columns="columns"
      :rows="products"
      :search-options="{ enabled: true}"
      :sort-options="{ enabled: true}"
      :pagination-options="{ enabled: true}"
      :select-options="{ enabled: true}"
    >
      <div slot="selected-row-actions">
        <vue-excel-xlsx :data="selectedProducts" :columns="columns">Export</vue-excel-xlsx>
      </div>
    </vue-good-table>
  </div>
</template>

<script>
import axios from "axios";
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";

export default {
  components: {
    VueGoodTable
  },
  data() {
    return {
      ausg: "",
      kf: "",
      ap1: "",
      ap2: "",
      ap3: "",
      db1: "",
      kvar: "",
      fakt: "",

      columns: [
        {
          label: "Id",
          field: "product_id",
          thClass: "font-semibold text-xs",
          tdClass: "text-xs"
        },
        {
          label: "Name",
          field: "name",
          thClass: "font-semibold text-xs",
          tdClass: "text-xs"
        },
        {
          label: "Price",
          field: "price",
          thClass: "font-semibold text-xs",
          tdClass: "text-xs"
        },
        {
          label: "Cbm",
          field: "cbm",
          thClass: "font-semibold text-xs",
          tdClass: "text-xs"
        },
        {
          label: "Ausg Fracht",
          field: "ausg",
          thClass: "font-semibold text-xs",
          tdClass: "text-xs"
        },
        {
          label: "Einst",
          field: "einst",
          thClass: "font-semibold text-xs",
          tdClass: "text-xs"
        },
        {
          label: "Db1",
          field: "db1",
          thClass: "font-semibold text-xs",
          tdClass: "text-xs"
        },
        {
          label: "Db1 €",
          field: "db1e",
          thClass: "font-semibold text-xs",
          tdClass: "text-xs"
        },
        {
          label: "Porno",
          field: "porno",
          thClass: "font-semibold text-xs",
          tdClass: "text-xs"
        },
        {
          label: "Kvar",
          field: "kvar",
          thClass: "font-semibold text-xs",
          tdClass: "text-xs"
        },
        {
          label: "Db2 €",
          field: "db2e",
          thClass: "font-semibold text-xs",
          tdClass: "text-xs"
        },
        {
          label: "Db2 %",
          field: "db2p",
          thClass: "font-semibold text-xs",
          tdClass: "text-xs"
        },
        {
          label: "PU kalk n/n",
          field: "pu kalk",
          thClass: "font-semibold text-xs",
          tdClass: "text-xs"
        },
        {
          label: "Fakt",
          field: "fakt",
          thClass: "font-semibold text-xs",
          tdClass: "text-xs"
        },
        {
          label: "VK Werb PU",
          field: "vk werb",
          thClass: "font-semibold text-xs",
          tdClass: "text-xs"
        },
        {
          label: "PU",
          field: "pu",
          thClass: "font-semibold text-xs",
          tdClass: "text-xs"
        },
        {
          label: "AP G/B/A",
          field: "ap1",
          thClass: "font-semibold text-xs",
          tdClass: "text-xs"
        },
        {
          label: "AP AI/E/V",
          field: "ap2",
          thClass: "font-semibold text-xs",
          tdClass: "text-sm"
        },
        {
          label: "Freie",
          field: "freie",
          thClass: "font-semibold text-xs",
          tdClass: "text-sm"
        }
      ],
      products: [],
      selectedProducts: [],
      imms: [],
      imm: "",
      services: [],
      service: ""
    };
  },
  created() {
    this.getImms();
    this.getServices();
  },
  methods: {
    calculateImm() {
      axios
        .get(
          `${process.env.VUE_APP_API}/calculate/imm?imm_id=${this.imm}&postal_id=${this.service}`
        )
        .then(response => {
          this.products = response.data;
          // console.log(response);
        });
    },
    selectionChanged(params) {
      this.selectedProducts = params.selectedRows;
    },
    getImms() {
      axios
        .get(`${process.env.VUE_APP_API}/calculate/imm/all`)
        .then(response => {
          this.imms = response.data;
        });
    },
    getServices() {
      axios
        .get(`${process.env.VUE_APP_API}/calculate/services`)
        .then(response => {
          this.services = response.data;
        });
    }
  }
};
</script>

<style>
</style>